import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import { GetMembersQuery } from '@/api/organization/members/get-members-query'

interface IRevokeInvitationArgs {
    organizationId: string
    invitationId: string
}

export class RevokeInvitationMutation {
    static async call(api: IApi, args: IRevokeInvitationArgs) {
        return api
            .post(`/organization/${args.organizationId}/members/invitations/${args.invitationId}/revoke`, undefined)
            .then((res) => res.data)
    }
}

export function useRevokeInvitationMutation() {
    const { api, apiParams, qc } = useApiToolbox()

    return useApiMutation<unknown, { invitationId: string }>({
        mutationFn: ({ invitationId }) =>
            RevokeInvitationMutation.call(api, {
                organizationId: apiParams.organizationId,
                invitationId,
            }),
        onSuccess: () => {
            qc.invalidateQueries({
                queryKey: GetMembersQuery.getKey({ organizationId: apiParams.organizationId }),
            })
        },
    })
}
